import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Login } from '../actions/login';

const LoginPage = ({ Login, username, password, history }) => {
  const [userData, setUserData] = useState({ Username: '', Password: '' });
  const [isLoginClick, setIsLoginClick] = useState(false);

  useEffect(() => {
    if (username !== '' && password) {
      history.push('/');
      setIsLoginClick(false);
    }
  }, [username, password, isLoginClick]);

  const handleLoginClick = () => {
    Login(userData.Username, userData.Password);
    setIsLoginClick(true);
  };

  const handleUserDataOnChange = (e) => {
    const newUserData = { ...userData };
    newUserData[e.target.name] = e.target.value;
    setUserData(newUserData);
  };

  return (
    <Page>
      <Title>Авторизация</Title>
      <Input
        placeholder="Введите имя пользователя"
        type="text"
        name="Username"
        value={userData.Username}
        onChange={(e) => handleUserDataOnChange(e)}
      />
      <Input
        placeholder="Введите пароль"
        type="password"
        name="Password"
        value={userData.Password}
        onChange={(e) => handleUserDataOnChange(e)}
      />
      <Button onClick={handleLoginClick}>Войти</Button>
    </Page>
  );
};

const mapStateToProps = (state) => {
  const { username, password } = state.login;
  return {
    username,
    password,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    Login: (username, password) => {
      dispatch(Login(username, password));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginPage));

const Page = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  padding-top: 100px;
`;

const Title = styled.h1`
  display: block;
  font-size: 48px;
  text-align: center;
  margin: 0 auto;
`;

const Input = styled.input`
  display: block;
  margin: 30px auto;
  width: 300px;
  height: 50px;
  font-size: 20px;
  text-align: center;
  border-radius: 5px;
`;

const Button = styled.button`
  display: block;
  margin: 30px auto;
  font-size: 20px;
  width: 300px;
  height: 50px;
  background: #3a3a3a;
  border: none;
  color: #fff;
  border-radius: 5px;
  &:hover {
    background: #4f93c3;
    color: #000542;
    border: 1px solid #000542;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/LoginPage.jsx